class CanvasContext {
  constructor () {
    this.x = 0
    this.y = 0
    this.width = 128
    this.height = 128
    this.scale = 1
    this.rotation = 0
  }
}

class CanvasBuffer {
  constructor (element, args) {
    let fragment = document.createDocumentFragment()

    this.image = args.image ? args.image : null

    this.canvas = document.createElement('canvas')
    this.canvas.width = 128
    this.canvas.height = 128

    this.context = null

    fragment.appendChild(this.canvas)

    element.appendChild(fragment)
  }

  getImage () {
    return this.image
  }

  clearImage () {
    this.context = new CanvasContext()

    let graphicsContext = this.canvas.getContext('2d')

    graphicsContext.fillStyle = '#fff'
    graphicsContext.fillRect(0, 0, this.canvas.width, this.canvas.height)

    this.image = null
  }

  setImage (imageElement) {
    this.context = new CanvasContext()

    let s = imageElement.width > imageElement.height ? imageElement.width / imageElement.height : imageElement.height / imageElement.width
    this.context.width = imageElement.width < imageElement.height ? imageElement.width * s : imageElement.height * s
    this.context.height = this.context.width
    this.context.x = imageElement.width / 2 - this.context.width / 2
    this.context.y = imageElement.height / 2 - this.context.height / 2

    this.renderImage(imageElement)

    this.image = this.canvas.toDataURL('image/jpeg', 0.9)
  }

  rotateImage (imageElement) {
    this.context.rotation = (this.context.rotation + Math.PI / 2) % (Math.PI * 2)
    this.renderImage(imageElement)

    this.image = this.canvas.toDataURL('image/jpeg', 0.9)
  }

  renderImage (img) {
    let graphicsContext = this.canvas.getContext('2d')

    graphicsContext.fillStyle = '#fff'
    graphicsContext.fillRect(0, 0, this.canvas.width, this.canvas.height)
    graphicsContext.translate(this.canvas.width / 2, this.canvas.height / 2)
    graphicsContext.rotate(this.context.rotation)
    graphicsContext.translate(-this.canvas.width / 2, -this.canvas.height / 2)
    graphicsContext.drawImage(img, this.context.x, this.context.y, this.context.width, this.context.height, 0, 0, this.canvas.width, this.canvas.height)
    graphicsContext.setTransform(1, 0, 0, 1, 0, 0)
  }
}

export default class ImagePickerControl {
  constructor (element, args) {
    this.element = element
    let fragment = document.createDocumentFragment()
    this.image = args.image ? args.image : null
    this.img = null

    let dropHandler = (event) => {
      event.preventDefault()
      if (event.dataTransfer.items && event.dataTransfer.items.length > 0) {
        let result = null
        let url = null

        for (let i = 0; i < event.dataTransfer.items.length; i++) {
          if (event.dataTransfer.items[i].type.indexOf('image/') === 0) {
            result = event.dataTransfer.items[i]
            break
          }

          if (!url && event.dataTransfer.items[i].type === 'text/plain') {
            url = event.dataTransfer.items[i]
          }
        }

        if (result) {
          this.setImage(URL.createObjectURL(result.getAsFile()))
        } else if (url) {
          url.getAsString((s) => {
            this.setImage(s)
          })
        }
      }
    }

    let dragoverHandler = (event) => {
      event.preventDefault()
    }

    let filePickerChanged = (event) => {
      if (event.target.files && event.target.files.length > 0) {
        this.setImage(URL.createObjectURL(event.target.files[0]))
      }
    }

    this.filePicker = document.createElement('input')
    this.filePicker.type = 'file'
    this.filePicker.accept = 'image/*'
    this.filePicker.className = 'invisible'
    this.filePicker.onchange = filePickerChanged

    this.canvas = new CanvasBuffer(fragment, {})

    this.imageLoaded = () => {
      this.canvas.setImage(this.img)
      this.image = this.canvas.getImage()
    }

    this.imageFailed = () => {
      if (this.img) {
        this.element.removeChild(this.img)
      }

      this.img = null
      alert('Kon afbeelding niet laden. Kies een andere of probeer opnieuw.')
    }

    if (this.image) {
      this.img = document.createElement('img')
      this.img.src = this.image
      this.img.className = 'invisible'
      this.img.crossOrigin = 'anonymous'
      this.img.onload = this.imageLoaded
      this.img.onerror = this.imageFailed

      fragment.appendChild(this.img)
    }

    this.element.ondrop = dropHandler
    this.element.ondragover = dragoverHandler

    this.element.appendChild(fragment)
  }

  getImage () {
    return this.image
  }

  setImage (newImage) {
    if (this.img) {
      if (this.img.src) {
        URL.revokeObjectURL(this.img.src)
      }

      this.element.removeChild(this.img)
      this.img = null
    }

    this.img = document.createElement('img')
    this.img.src = newImage
    this.img.className = 'invisible'
    this.img.crossOrigin = 'anonymous'
    this.img.onload = this.imageLoaded
    this.img.onerror = this.imageFailed

    this.element.appendChild(this.img)
  }

  rotateImage () {
    if (this.img) {
      this.canvas.rotateImage(this.img)
    }
  }

  clearImage () {
    if (this.img) {
      if (this.img.src) {
        URL.revokeObjectURL(this.img.src)
      }

      this.element.removeChild(this.img)
      this.img = null
    }

    this.image = null
    this.canvas.clearImage()
  }

  onselect () {
    this.filePicker.click()
  }

  pasteHandler (event) {
    event.preventDefault()
    if (event.clipboardData.items && event.clipboardData.items.length > 0) {
      let result = null

      for (let i = 0; i < event.clipboardData.items.length; i++) {
        if (event.clipboardData.items[i].type.indexOf('image/') === 0) {
          result = event.clipboardData.items[i]
          break
        }
      }

      if (result) {
        this.setImage(URL.createObjectURL(result.getAsFile()))
      }
    }
  }
}



// WEBPACK FOOTER //
// ./js/lib/ui/ImagePickerControl.js